import { __extends as B, __awaiter as M, __generator as y, __assign as R, __spreadArray as E } from "./index11.js";
import { getProcessEnv as k } from "./index30.js";
import { setGlobalCDNUrl as I, getCDN as V } from "./index31.js";
import { fetch as C } from "./index32.js";
import { Analytics as F } from "./index7.js";
import { mergedOptions as Q } from "./index33.js";
import { createDeferred as U } from "./index34.js";
import { pageEnrichment as z } from "./index35.js";
import { remoteLoader as K } from "./index36.js";
import { segmentio as T } from "./index37.js";
import { validation as q } from "./index38.js";
import { AnalyticsBuffered as G, flushAnalyticsCallsInNewTask as W, flushAddSourceMiddleware as j, flushSetAnonymousID as H, flushOn as J } from "./index39.js";
import { popSnippetWindowBuffer as L } from "./index40.js";
import { attachInspector as X } from "./index41.js";
import { Stats as Y } from "./index42.js";
function Z(r, e) {
  var n = e ?? V();
  return C("".concat(n, "/v1/projects/").concat(r, "/settings")).then(function(t) {
    return t.ok ? t.json() : t.text().then(function(u) {
      throw new Error(u);
    });
  }).catch(function(t) {
    throw console.error(t.message), t;
  });
}
function $(r) {
  return k().NODE_ENV !== "test" && // just one integration means segmentio
  Object.keys(r.integrations).length > 1;
}
function ee(r) {
  var e, n, t;
  return k().NODE_ENV !== "test" && ((t = (n = (e = r.middlewareSettings) === null || e === void 0 ? void 0 : e.routingRules) === null || n === void 0 ? void 0 : n.length) !== null && t !== void 0 ? t : 0) > 0;
}
function re(r, e) {
  e.push.apply(e, L()), H(r, e), J(r, e);
}
function te(r, e) {
  return M(this, void 0, void 0, function() {
    return y(this, function(n) {
      switch (n.label) {
        case 0:
          return e.push.apply(e, L()), [4, j(r, e)];
        case 1:
          return n.sent(), e.push.apply(e, L()), W(r, e), e.clear(), [
            2
            /*return*/
          ];
      }
    });
  });
}
function ne(r, e, n, t, u, f) {
  var s, a, c;
  return M(this, void 0, void 0, function() {
    var d, h, w, g, m, o, b, S, v, _, A, D = this;
    return y(this, function(i) {
      switch (i.label) {
        case 0:
          return ee(r) ? [4, import(
            /* webpackChunkName: "tsub-middleware" */
            "./index25.js"
          ).then(function(l) {
            return l.tsubMiddleware(r.middlewareSettings.routingRules);
          })] : [3, 2];
        case 1:
          return h = i.sent(), [3, 3];
        case 2:
          h = void 0, i.label = 3;
        case 3:
          return d = h, $(r) || f.length > 0 ? [4, import(
            /* webpackChunkName: "ajs-destination" */
            "./index26.js"
          ).then(function(l) {
            return l.ajsDestinations(r, e.integrations, n, d, f);
          })] : [3, 5];
        case 4:
          return g = i.sent(), [3, 6];
        case 5:
          g = [], i.label = 6;
        case 6:
          return w = g, r.legacyVideoPluginsEnabled ? [4, import(
            /* webpackChunkName: "legacyVideos" */
            "./index27.js"
          ).then(function(l) {
            return l.loadLegacyVideoPlugins(e);
          })] : [3, 8];
        case 7:
          i.sent(), i.label = 8;
        case 8:
          return !((s = n.plan) === null || s === void 0) && s.track ? [4, import(
            /* webpackChunkName: "schemaFilter" */
            "./index28.js"
          ).then(function(l) {
            var p;
            return l.schemaFilter((p = n.plan) === null || p === void 0 ? void 0 : p.track, r);
          })] : [3, 10];
        case 9:
          return o = i.sent(), [3, 11];
        case 10:
          o = void 0, i.label = 11;
        case 11:
          return m = o, b = Q(r, t), [4, K(r, e.integrations, b, t.obfuscate, d).catch(function() {
            return [];
          })];
        case 12:
          return S = i.sent(), v = E(E(E([
            q,
            z
          ], u, !0), w, !0), S, !0), m && v.push(m), _ = ((a = n.integrations) === null || a === void 0 ? void 0 : a.All) === !1 && !n.integrations["Segment.io"] || n.integrations && n.integrations["Segment.io"] === !1, _ || v.push(T(e, b["Segment.io"], r.integrations)), [4, e.register.apply(e, v)];
        case 13:
          return A = i.sent(), Object.entries((c = r.enabledMiddleware) !== null && c !== void 0 ? c : {}).some(function(l) {
            var p = l[1];
            return p;
          }) ? [4, import(
            /* webpackChunkName: "remoteMiddleware" */
            "./index29.js"
          ).then(function(l) {
            var p = l.remoteMiddlewares;
            return M(D, void 0, void 0, function() {
              var P, N;
              return y(this, function(O) {
                switch (O.label) {
                  case 0:
                    return [4, p(A, r, t.obfuscate)];
                  case 1:
                    return P = O.sent(), N = P.map(function(x) {
                      return e.addSourceMiddleware(x);
                    }), [2, Promise.all(N)];
                }
              });
            });
          })] : [3, 15];
        case 14:
          i.sent(), i.label = 15;
        case 15:
          return [2, A];
      }
    });
  });
}
function ie(r, e, n) {
  var t, u, f, s, a, c, d;
  return e === void 0 && (e = {}), M(this, void 0, void 0, function() {
    var h, w, g, m, o, b, S, v, _, A, D;
    return y(this, function(i) {
      switch (i.label) {
        case 0:
          return r.cdnURL && I(r.cdnURL), (t = r.cdnSettings) !== null && t !== void 0 ? (w = t, [3, 3]) : [3, 1];
        case 1:
          return [4, Z(r.writeKey, r.cdnURL)];
        case 2:
          w = i.sent(), i.label = 3;
        case 3:
          return h = w, g = (f = (u = h.integrations["Segment.io"]) === null || u === void 0 ? void 0 : u.retryQueue) !== null && f !== void 0 ? f : !0, m = R({ retryQueue: g }, e), o = new F(r, m), X(o), b = (s = r.plugins) !== null && s !== void 0 ? s : [], S = (a = r.classicIntegrations) !== null && a !== void 0 ? a : [], Y.initRemoteMetrics(h.metrics), re(o, n), [4, ne(h, o, m, e, b, S)];
        case 4:
          return v = i.sent(), _ = (c = window.location.search) !== null && c !== void 0 ? c : "", A = (d = window.location.hash) !== null && d !== void 0 ? d : "", D = _.length ? _ : A.replace(/(?=#).*(?=\?)/, ""), D.includes("ajs_") ? [4, o.queryString(D).catch(console.error)] : [3, 6];
        case 5:
          i.sent(), i.label = 6;
        case 6:
          return o.initialized = !0, o.emit("initialize", r, e), e.initialPageview && o.page().catch(console.error), [4, te(o, n)];
        case 7:
          return i.sent(), [2, [o, v]];
      }
    });
  });
}
var _e = (
  /** @class */
  function(r) {
    B(e, r);
    function e() {
      var n = this, t = U(), u = t.promise, f = t.resolve;
      return n = r.call(this, function(s) {
        return u.then(function(a) {
          var c = a[0], d = a[1];
          return ie(c, d, s);
        });
      }) || this, n._resolveLoadStart = function(s, a) {
        return f([s, a]);
      }, n;
    }
    return e.prototype.load = function(n, t) {
      return t === void 0 && (t = {}), this._resolveLoadStart(n, t), this;
    }, e.load = function(n, t) {
      return t === void 0 && (t = {}), new e().load(n, t);
    }, e.standalone = function(n, t) {
      return e.load({ writeKey: n }, t).then(function(u) {
        return u[0];
      });
    }, e;
  }(G)
);
export {
  _e as AnalyticsBrowser,
  Z as loadLegacySettings
};
//# sourceMappingURL=index6.js.map
